'use client';

import PlatinumMicrophoneSVG from '@/context/global/assets/PlatinumMicrophone';
import CWPopup from '@/context/global/components/g00/g00-d00-g007-cw-popup';
import { useTranslations } from 'next-intl';

export interface IModalPackageUpgradeProps {
  message?: string;
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
  onNextSong: () => void;
  hideNextSong?: boolean;
}

export default function ModalPackageUpgrade({
  message,
  isOpen,
  onClose,
  onRetry,
  onNextSong,
  hideNextSong,
}: IModalPackageUpgradeProps) {
  const t = useTranslations('PackageUpgrade');

  return (
    <CWPopup
      isOpen={isOpen}
      onClose={onClose}
      title={message || t('title')}
      leftButtonText={t('retry')}
      rightButtonText={hideNextSong ? undefined : t('nextSong')}
      onLeftButtonClick={onRetry}
      onRightButtonClick={hideNextSong ? undefined : onNextSong}
      topElement={
        <div className="h-[130px] w-[130px] md:h-[230px] md:w-[230px] md:max-w-[416px] [&>svg]:h-full [&>svg]:w-full">
          <PlatinumMicrophoneSVG />
        </div>
      }
      className="md:w-max-[416px] md:px-[128px]"
      rightButtonProps={{ variant: 'white' }}
    />
  );
}
